import React from 'react';
import { Clock, ChevronLeft, ChevronRight } from 'lucide-react';

const VersionHistory = ({ 
  history = [], 
  currentVersion = 0, 
  onVersionChange,
  label = "Version"
}) => {
  if (history.length <= 1) return null;

  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diff = now - date;
    
    if (diff < 60000) return 'Just now';
    if (diff < 3600000) return `${Math.floor(diff / 60000)} min ago`;
    if (diff < 86400000) return `${Math.floor(diff / 3600000)} hours ago`;
    return date.toLocaleDateString();
  };

  const currentItem = history[currentVersion];

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      padding: '12px 16px',
      background: 'linear-gradient(to right, #f8f9fa, #ffffff)',
      borderRadius: '8px',
      border: '1px solid #e5e7eb',
      marginBottom: '16px'
    }}>
      <Clock style={{ width: '16px', height: '16px', color: '#6b7280' }} />
      
      <button
        onClick={() => onVersionChange(Math.max(0, currentVersion - 1))}
        disabled={currentVersion === 0}
        style={{
          padding: '4px',
          background: currentVersion === 0 ? '#f3f4f6' : 'white',
          border: '1px solid #e5e7eb',
          borderRadius: '4px',
          cursor: currentVersion === 0 ? 'not-allowed' : 'pointer',
          display: 'flex',
          alignItems: 'center',
          opacity: currentVersion === 0 ? 0.5 : 1,
          transition: 'all 0.2s'
        }}
      >
        <ChevronLeft style={{ width: '14px', height: '14px' }} />
      </button>

      <div style={{ flex: 1, textAlign: 'center' }}>
        <span style={{
          fontSize: '13px',
          fontWeight: '600',
          color: '#111827'
        }}>
          {label} {currentVersion + 1} of {history.length}
        </span>
        {currentItem && (
          <>
            <span style={{
              margin: '0 8px',
              color: '#e5e7eb'
            }}>•</span>
            <span style={{
              fontSize: '12px',
              color: '#6b7280'
            }}>
              {formatTime(currentItem.timestamp)}
            </span>
            {currentItem.context && (
              <>
                <span style={{
                  margin: '0 8px',
                  color: '#e5e7eb'
                }}>•</span>
                <span style={{
                  fontSize: '12px',
                  color: '#8b5cf6',
                  fontStyle: 'italic'
                }}>
                  With context
                </span>
              </>
            )}
          </>
        )}
      </div>

      <button
        onClick={() => onVersionChange(Math.min(history.length - 1, currentVersion + 1))}
        disabled={currentVersion === history.length - 1}
        style={{
          padding: '4px',
          background: currentVersion === history.length - 1 ? '#f3f4f6' : 'white',
          border: '1px solid #e5e7eb',
          borderRadius: '4px',
          cursor: currentVersion === history.length - 1 ? 'not-allowed' : 'pointer',
          display: 'flex',
          alignItems: 'center',
          opacity: currentVersion === history.length - 1 ? 0.5 : 1,
          transition: 'all 0.2s'
        }}
      >
        <ChevronRight style={{ width: '14px', height: '14px' }} />
      </button>
    </div>
  );
};

export default VersionHistory;